class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.button = null;
    this.threshold = 50;
    this.visible = false;
    this.controller = new AbortController();
  }

  connectedCallback() {
    this.threshold = parseInt(this.getAttribute('data-threshold')) || 50;
    this.visible = false;

    this.button = this.querySelector('button');
    this.button.addEventListener(
      'click',
      () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      { signal: this.controller.signal }
    );

    this.onScroll = () => {
      const scrollableHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      if (scrollableHeight <= 0) return;
      const scrollPercent = (window.scrollY / scrollableHeight) * 100;
      const shouldShow = scrollPercent >= this.threshold;

      if (shouldShow !== this.visible) {
        this.visible = shouldShow;
        this.button.classList.toggle('opacity-0', !shouldShow);
        this.button.classList.toggle('pointer-events-none', !shouldShow);
        this.button.classList.toggle('opacity-100', shouldShow);
      }
    };

    window.addEventListener('scroll', this.onScroll, {
      passive: true,
      signal: this.controller.signal,
    });
    this.onScroll();
  }

  disconnectedCallback() {
    this.controller.abort();
  }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop);
}
